/**
 * Partner companies — mirrors `salescrmapi/src/modules/partners`.
 * docs/modules/partnerLeads.model.md §3.
 *
 * No mock fallback — same reasoning as `masterData.api.js`: the backend
 * module is real, so a fixture here would just be a second, drifting copy of
 * a shape the server already returns.
 */
import apiClient, { ifMatch, idempotencyKey } from './axiosClient.js';

/** @param {{limit?:number, cursor?:string, q?:string, partner_type?:string, is_active?:boolean, sort?:string}} params */
export async function listPartners(params = {}) {
  const { data } = await apiClient.get('/partners', { params });
  return data;
}

export async function getPartner(id) {
  const { data } = await apiClient.get(`/partners/${id}`);
  return data;
}

export async function createPartner(payload) {
  const { data } = await apiClient.post('/partners', payload, { headers: idempotencyKey() });
  return data;
}

export async function updatePartner(id, payload, rowVersion) {
  const { data } = await apiClient.patch(`/partners/${id}`, payload, { headers: ifMatch(rowVersion) });
  return data;
}
